import React from 'react';
import styled from 'styled-components';
import { ProjectDropdown } from '../ProjectDropdown';
const Container = styled.div `
  background-color: #fff;
  color: ${({ theme }) => theme.greys.fjord};
  display: flex;
  height: 64px;
  justify-content: space-between;
  padding: 0 24px;
`;
const DocsLinkUserDropdownContainer = styled.div `
  display: flex;
  align-items: center;
`;
const DocsLinkContainer = styled.div `
  display: flex;
  align-items: center;
  text-align: center;
  height: 32px;
  border-right: solid 1px ${({ theme }) => theme.greys.geyser};
  margin-right: 16px;
  padding-right: 16px;
  a {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.sudoBlue};
  }
`;
export const AppHeader = ({ projectDropdownProps, UserDropdown, }) => (React.createElement(Container, { className: "header" },
    React.createElement("div", null,
        React.createElement(ProjectDropdown, { ...projectDropdownProps })),
    React.createElement(DocsLinkUserDropdownContainer, null,
        React.createElement(DocsLinkContainer, null,
            React.createElement("a", { href: "https://docs.sudoplatform.com/", target: "_blank", rel: "noopener noreferrer" }, "Developer Docs")),
        React.createElement(UserDropdown, null))));
